import { useEffect } from "react";
import { connect } from "react-redux";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../../../../firebase";
import { updateFCMToken } from "./authCrud";
import * as auth from "./authRedux";

function AuthInit(props) {
  useEffect(() => {  
    // Mesajlaşma izni iste ve Token al
    const requestPermission = async () => {
      const permission = await Notification.requestPermission();
      
      if (permission === "granted") {
        const token = await getToken(messaging, { 
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY 
        });
        console.log('FCM Token:', token);

        if (token !== props.token) {
          props.setFCMToken(token);
          updateFCMToken(token);
        }
      }
    };
  
    requestPermission();
  
    // Uygulama açıkken mesaj geldiğinde:
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Mesaj geldi:', payload);
  
      const targetUrl = payload.data.click_action || '/';
      const notificationTitle = payload.data.title;
      const notificationOptions = {
        body: payload.data.body,
        icon: '/media/logos/favicon.ico'
      };
  
      const notification = new Notification(notificationTitle, notificationOptions);  
      notification.onclick = () => window.open(targetUrl, "_blank", "noopener, noreferrer");
    });
  
    return () => unsubscribe();
  }, []);

  return <>{props.children}</>;
}

export default connect(({ auth }) => ({ token: auth.token }), auth.actions)(AuthInit);